import { CornerDotTypes } from "../types";

export default {
  dot: "dot",
  square: "square",
  extraRounded: "extra-rounded",
  oneClassy: "one-classy",
  classy: "classy",
  oneClassyRotate: "one-classy-rotate",
  classyReflect: "classy-reflect",
  rhombus: "rhombus",
  rhombusExtraRounded: "rhombus-extra-rounded",
  star: "star",
  gear: "gear"
} as CornerDotTypes;
